var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};

(function ($) {

  // Findation Tool Integration

  var enableFindation = Drupal.settings.global_variables?.enable_findation;
  var findationButton = $('#findation-widget-button').length > 0;

  if (enableFindation && findationButton) {
    $.getScript('//findation.com/javascripts/w-adv-1.js', function () {
      window.Findation = window.Findation || {};
      var initWidget = initWidget || {};

      initWidget = function () {
        Findation.init(
          document.getElementById('findation-widget-button'),
          'fe2999e3ad1ffda62b60b7e60fb9fd165886e33dd9c12d28fe5ce0f58ea3',
          {}
        );
      };
      initWidget();
    });
  }

  $(document).on('inv_status_data:updated', '.js-product', function (e) {
    var $statusList = $('.js-inv-status-list', $(this));
    var skuBaseId = $statusList.data('sku-base-id');
    var skuData = prodcat.data.getSku(skuBaseId);

    if (!!skuData) {
      Drupal.behaviors.inventoryStatusV1.update($statusList, skuData);
    }
  });

  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId) {
    var $statusList = $('.js-inv-status-list', $(this));

    if ($statusList.length < 1) {
      return null;
    }
    Drupal.behaviors.inventoryStatusV1.selectSku($statusList, skuBaseId);
  });

  $(document).on('mouseout', '.js-swatch-list-item-link', function () {
    var $swatchList = $(this).closest('.js-swatch-list');
    var skuBaseId = $swatchList.data('sku-base-id');
    var $productEl = prodcat.ui.getProductEl($swatchList);

    $productEl.trigger('product.skuDisplay', skuBaseId);
  });

  Drupal.behaviors.inventoryStatusV1 = {

    update: function ($statusList, skuData) {
      var skuBaseId = $statusList.data('sku-base-id');

      if (!skuData || !skuData.INVENTORY_STATUS) {
        return null;
      }
      if (skuData.SKU_ID !== 'SKU' + skuBaseId) {
        return null;
      }
      $('li', $statusList).hide();
      var $statusToShow = $('.js-inv-status-' + skuData.INVENTORY_STATUS, $statusList);

      if ($statusToShow.length > 0) {
        $statusToShow.show();
      }
      $statusList.trigger('inv_status_display:updated');
    },

    selectSku: function ($statusList, skuBaseId) {
      $statusList.data('sku-base-id', skuBaseId);
      var skuData = prodcat.data.getSku(skuBaseId);

      Drupal.behaviors.inventoryStatusV1.update($statusList, skuData);
    }
  };
})(jQuery);
